import $e, { createContext as gr, forwardRef as yr, useContext as Er } from "react";
import { c as br } from "./index.mjs";
var ee = { exports: {} }, D = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ce;
function Rr() {
  if (Ce)
    return D;
  Ce = 1;
  var E = $e, c = Symbol.for("react.element"), S = Symbol.for("react.fragment"), T = Object.prototype.hasOwnProperty, M = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, V = { key: !0, ref: !0, __self: !0, __source: !0 };
  function $(R, d, A) {
    var h, b = {}, _ = null, I = null;
    A !== void 0 && (_ = "" + A), d.key !== void 0 && (_ = "" + d.key), d.ref !== void 0 && (I = d.ref);
    for (h in d)
      T.call(d, h) && !V.hasOwnProperty(h) && (b[h] = d[h]);
    if (R && R.defaultProps)
      for (h in d = R.defaultProps, d)
        b[h] === void 0 && (b[h] = d[h]);
    return { $$typeof: c, type: R, key: _, ref: I, props: b, _owner: M.current };
  }
  return D.Fragment = S, D.jsx = $, D.jsxs = $, D;
}
var k = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function _r() {
  return Oe || (Oe = 1, process.env.NODE_ENV !== "production" && function() {
    var E = $e, c = Symbol.for("react.element"), S = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), M = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), $ = Symbol.for("react.provider"), R = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), A = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), I = Symbol.for("react.offscreen"), re = Symbol.iterator, Fe = "@@iterator";
    function De(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = re && e[re] || e[Fe];
      return typeof r == "function" ? r : null;
    }
    var C = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function f(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        ke("error", e, t);
      }
    }
    function ke(e, r, t) {
      {
        var n = C.ReactDebugCurrentFrame, i = n.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var s = t.map(function(a) {
          return String(a);
        });
        s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var Me = !1, Ve = !1, Ie = !1, Le = !1, Ne = !1, te;
    te = Symbol.for("react.module.reference");
    function We(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === T || e === V || Ne || e === M || e === A || e === h || Le || e === I || Me || Ve || Ie || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === b || e.$$typeof === $ || e.$$typeof === R || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === te || e.getModuleId !== void 0));
    }
    function Ye(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function ne(e) {
      return e.displayName || "Context";
    }
    function y(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && f("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case T:
          return "Fragment";
        case S:
          return "Portal";
        case V:
          return "Profiler";
        case M:
          return "StrictMode";
        case A:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case R:
            var r = e;
            return ne(r) + ".Consumer";
          case $:
            var t = e;
            return ne(t._context) + ".Provider";
          case d:
            return Ye(e, e.render, "ForwardRef");
          case b:
            var n = e.displayName || null;
            return n !== null ? n : y(e.type) || "Memo";
          case _: {
            var i = e, s = i._payload, a = i._init;
            try {
              return y(a(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var m = Object.assign, j = 0, oe, ae, ie, se, ce, ue, le;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function ze() {
      {
        if (j === 0) {
          oe = console.log, ae = console.info, ie = console.warn, se = console.error, ce = console.group, ue = console.groupCollapsed, le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        j++;
      }
    }
    function Be() {
      {
        if (j--, j === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: m({}, e, {
              value: oe
            }),
            info: m({}, e, {
              value: ae
            }),
            warn: m({}, e, {
              value: ie
            }),
            error: m({}, e, {
              value: se
            }),
            group: m({}, e, {
              value: ce
            }),
            groupCollapsed: m({}, e, {
              value: ue
            }),
            groupEnd: m({}, e, {
              value: le
            })
          });
        }
        j < 0 && f("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B = C.ReactCurrentDispatcher, U;
    function L(e, r, t) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (i) {
            var n = i.stack.trim().match(/\n( *(at )?)/);
            U = n && n[1] || "";
          }
        return `
` + U + e;
      }
    }
    var J = !1, N;
    {
      var Ue = typeof WeakMap == "function" ? WeakMap : Map;
      N = new Ue();
    }
    function de(e, r) {
      if (!e || J)
        return "";
      {
        var t = N.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      J = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = B.current, B.current = null, ze();
      try {
        if (r) {
          var a = function() {
            throw Error();
          };
          if (Object.defineProperty(a.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(a, []);
            } catch (p) {
              n = p;
            }
            Reflect.construct(e, [], a);
          } else {
            try {
              a.call();
            } catch (p) {
              n = p;
            }
            e.call(a.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (p) {
            n = p;
          }
          e();
        }
      } catch (p) {
        if (p && n && typeof p.stack == "string") {
          for (var o = p.stack.split(`
`), v = n.stack.split(`
`), u = o.length - 1, l = v.length - 1; u >= 1 && l >= 0 && o[u] !== v[l]; )
            l--;
          for (; u >= 1 && l >= 0; u--, l--)
            if (o[u] !== v[l]) {
              if (u !== 1 || l !== 1)
                do
                  if (u--, l--, l < 0 || o[u] !== v[l]) {
                    var g = `
` + o[u].replace(" at new ", " at ");
                    return e.displayName && g.includes("<anonymous>") && (g = g.replace("<anonymous>", e.displayName)), typeof e == "function" && N.set(e, g), g;
                  }
                while (u >= 1 && l >= 0);
              break;
            }
        }
      } finally {
        J = !1, B.current = s, Be(), Error.prepareStackTrace = i;
      }
      var P = e ? e.displayName || e.name : "", w = P ? L(P) : "";
      return typeof e == "function" && N.set(e, w), w;
    }
    function Je(e, r, t) {
      return de(e, !1);
    }
    function Ke(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function W(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return de(e, Ke(e));
      if (typeof e == "string")
        return L(e);
      switch (e) {
        case A:
          return L("Suspense");
        case h:
          return L("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return Je(e.render);
          case b:
            return W(e.type, r, t);
          case _: {
            var n = e, i = n._payload, s = n._init;
            try {
              return W(s(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var x = Object.prototype.hasOwnProperty, ve = {}, pe = C.ReactDebugCurrentFrame;
    function Y(e) {
      if (e) {
        var r = e._owner, t = W(e.type, e._source, r ? r.type : null);
        pe.setExtraStackFrame(t);
      } else
        pe.setExtraStackFrame(null);
    }
    function qe(e, r, t, n, i) {
      {
        var s = Function.call.bind(x);
        for (var a in e)
          if (s(e, a)) {
            var o = void 0;
            try {
              if (typeof e[a] != "function") {
                var v = Error((n || "React class") + ": " + t + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              o = e[a](r, a, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (u) {
              o = u;
            }
            o && !(o instanceof Error) && (Y(i), f("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, a, typeof o), Y(null)), o instanceof Error && !(o.message in ve) && (ve[o.message] = !0, Y(i), f("Failed %s type: %s", t, o.message), Y(null));
          }
      }
    }
    var Ge = Array.isArray;
    function K(e) {
      return Ge(e);
    }
    function Xe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function He(e) {
      try {
        return he(e), !1;
      } catch {
        return !0;
      }
    }
    function he(e) {
      return "" + e;
    }
    function ge(e) {
      if (He(e))
        return f("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xe(e)), he(e);
    }
    var F = C.ReactCurrentOwner, Ze = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ye, Ee, q;
    q = {};
    function Qe(e) {
      if (x.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function er(e) {
      if (x.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function rr(e, r) {
      if (typeof e.ref == "string" && F.current && r && F.current.stateNode !== r) {
        var t = y(F.current.type);
        q[t] || (f('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', y(F.current.type), e.ref), q[t] = !0);
      }
    }
    function tr(e, r) {
      {
        var t = function() {
          ye || (ye = !0, f("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function nr(e, r) {
      {
        var t = function() {
          Ee || (Ee = !0, f("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var or = function(e, r, t, n, i, s, a) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: c,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: a,
        // Record the component responsible for creating this element.
        _owner: s
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function ar(e, r, t, n, i) {
      {
        var s, a = {}, o = null, v = null;
        t !== void 0 && (ge(t), o = "" + t), er(r) && (ge(r.key), o = "" + r.key), Qe(r) && (v = r.ref, rr(r, i));
        for (s in r)
          x.call(r, s) && !Ze.hasOwnProperty(s) && (a[s] = r[s]);
        if (e && e.defaultProps) {
          var u = e.defaultProps;
          for (s in u)
            a[s] === void 0 && (a[s] = u[s]);
        }
        if (o || v) {
          var l = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && tr(a, l), v && nr(a, l);
        }
        return or(e, o, v, i, n, F.current, a);
      }
    }
    var G = C.ReactCurrentOwner, be = C.ReactDebugCurrentFrame;
    function O(e) {
      if (e) {
        var r = e._owner, t = W(e.type, e._source, r ? r.type : null);
        be.setExtraStackFrame(t);
      } else
        be.setExtraStackFrame(null);
    }
    var X;
    X = !1;
    function H(e) {
      return typeof e == "object" && e !== null && e.$$typeof === c;
    }
    function Re() {
      {
        if (G.current) {
          var e = y(G.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ir(e) {
      return "";
    }
    var _e = {};
    function sr(e) {
      {
        var r = Re();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function me(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = sr(r);
        if (_e[t])
          return;
        _e[t] = !0;
        var n = "";
        e && e._owner && e._owner !== G.current && (n = " It was passed a child from " + y(e._owner.type) + "."), O(e), f('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), O(null);
      }
    }
    function we(e, r) {
      {
        if (typeof e != "object")
          return;
        if (K(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            H(n) && me(n, r);
          }
        else if (H(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = De(e);
          if (typeof i == "function" && i !== e.entries)
            for (var s = i.call(e), a; !(a = s.next()).done; )
              H(a.value) && me(a.value, r);
        }
      }
    }
    function cr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === b))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = y(r);
          qe(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !X) {
          X = !0;
          var i = y(r);
          f("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && f("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ur(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            O(e), f("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), O(null);
            break;
          }
        }
        e.ref !== null && (O(e), f("Invalid attribute `ref` supplied to `React.Fragment`."), O(null));
      }
    }
    var Te = {};
    function Ae(e, r, t, n, i, s) {
      {
        var a = We(e);
        if (!a) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var v = ir();
          v ? o += v : o += Re();
          var u;
          e === null ? u = "null" : K(e) ? u = "array" : e !== void 0 && e.$$typeof === c ? (u = "<" + (y(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : u = typeof e, f("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, o);
        }
        var l = ar(e, r, t, i, s);
        if (l == null)
          return l;
        if (a) {
          var g = r.children;
          if (g !== void 0)
            if (n)
              if (K(g)) {
                for (var P = 0; P < g.length; P++)
                  we(g[P], e);
                Object.freeze && Object.freeze(g);
              } else
                f("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              we(g, e);
        }
        if (x.call(r, "key")) {
          var w = y(e), p = Object.keys(r).filter(function(hr) {
            return hr !== "key";
          }), Z = p.length > 0 ? "{key: someKey, " + p.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Te[w + Z]) {
            var pr = p.length > 0 ? "{" + p.join(": ..., ") + ": ...}" : "{}";
            f(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Z, w, pr, w), Te[w + Z] = !0;
          }
        }
        return e === T ? ur(l) : cr(l), l;
      }
    }
    function lr(e, r, t) {
      return Ae(e, r, t, !0);
    }
    function fr(e, r, t) {
      return Ae(e, r, t, !1);
    }
    var dr = fr, vr = lr;
    k.Fragment = T, k.jsx = dr, k.jsxs = vr;
  }()), k;
}
process.env.NODE_ENV === "production" ? ee.exports = Rr() : ee.exports = _r();
var je = ee.exports;
const mr = ({ children: E, ...c }, S) => /* @__PURE__ */ je.jsx("a", { role: "button", ref: S, ...c, children: E }), xe = gr(
  /* @__PURE__ */ yr(mr)
);
function Mt({
  anchor: E,
  children: c
}) {
  return /* @__PURE__ */ je.jsx(xe.Provider, { value: E, children: c });
}
function Vt() {
  return Er(xe);
}
const wr = "번역보기", Tr = "원문보기", Ar = "더보기", Cr = "번역", Or = "도로명", Pr = "지번", Sr = "도로명주소", $r = "지번주소", jr = "우편번호", xr = "복사", Fr = "주행요금인하", Dr = "전기차", kr = "아침에 방문", Mr = "점심에 방문", Vr = "저녁에 방문", Ir = "밤에 방문", Q = {
  showTranslated: wr,
  showOriginal: Tr,
  showMore: Ar,
  translatedByPapago: Cr,
  roadAddress: Or,
  oldAddress: Pr,
  roadAddressFull: Sr,
  oldAddressFull: $r,
  zipCode: jr,
  copy: xr,
  carDiscount: Fr,
  electricVehicle: Dr,
  visitMorning: kr,
  visitAfternoon: Mr,
  visitEvening: Vr,
  visitNight: Ir
}, Lr = "View translation", Nr = "View original", Wr = "Translated by", Yr = "StreetName", zr = "LandLot", Br = "Road name address", Ur = "Lot number address", Jr = "Postal code", Kr = "Copy", qr = "Discount", Gr = "Electric Vehicle", Xr = "View more", Hr = "Morning", Zr = "Afternoon", Qr = "Evening", et = "Night", Pe = {
  showTranslated: Lr,
  showOriginal: Nr,
  translatedByPapago: Wr,
  roadAddress: Yr,
  oldAddress: zr,
  roadAddressFull: Br,
  oldAddressFull: Ur,
  zipCode: Jr,
  copy: Kr,
  carDiscount: qr,
  electricVehicle: Gr,
  showMore: Xr,
  visitMorning: Hr,
  visitAfternoon: Zr,
  visitEvening: Qr,
  visitNight: et
}, rt = "訳文を見る", tt = "原文を見る", nt = "Translated by", ot = "道路名", at = "番地", it = "道路名住所", st = "地番住所", ct = "郵便番号", ut = "コピー", lt = "走行料金の値下げ", ft = "電気自動車", dt = "もっと見る", vt = "朝に訪問", pt = "昼に訪問", ht = "晩に訪問", gt = "夜に訪問", Se = {
  showTranslated: rt,
  showOriginal: tt,
  translatedByPapago: nt,
  roadAddress: ot,
  oldAddress: at,
  roadAddressFull: it,
  oldAddressFull: st,
  zipCode: ct,
  copy: ut,
  carDiscount: lt,
  electricVehicle: ft,
  showMore: dt,
  visitMorning: vt,
  visitAfternoon: pt,
  visitEvening: ht,
  visitNight: gt
}, yt = "查看翻译", Et = "查看原文", bt = "Translated by", Rt = "街道", _t = "巷号", mt = "道路名住所", wt = "地番住所", Tt = "邮编", At = "复制", Ct = "行驶费用如下", Ot = "电动汽车", Pt = "更多", St = "早上来访", $t = "中午来访", jt = "傍晚来访", xt = "夜间来访", z = {
  showTranslated: yt,
  showOriginal: Et,
  translatedByPapago: bt,
  roadAddress: Rt,
  oldAddress: _t,
  roadAddressFull: mt,
  oldAddressFull: wt,
  zipCode: Tt,
  copy: At,
  carDiscount: Ct,
  electricVehicle: Ot,
  showMore: Pt,
  visitMorning: St,
  visitAfternoon: $t,
  visitEvening: jt,
  visitNight: xt
}, It = ["ko", "en", "ja", "zh-CN", "zh"], Ft = br.createLSFactory(), Lt = Ft(
  Object.keys(Q).reduce(
    (E, c) => ({
      ...E,
      [c]: {
        ...Q[c] && { ko: Q[c] },
        ...Pe[c] && { en: Pe[c] },
        ...Se[c] && { ja: Se[c] },
        ...z[c] && { "zh-CN": z[c] },
        ...z[c] && { zh: z[c] }
      }
    }),
    {}
  )
);
export {
  Mt as A,
  Lt as L,
  It as S,
  je as j,
  Vt as u
};
